import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { Crud_Catalogos } from "../herramientas/Crud_Catalogos";
import * as conf from "../config/config";

export const emptyTramo = {
  idMovimientoTipo: { value: 0, label: "Selecciona tipo de movimiento" },
  nombre: "",
  inicio: { value: 0, label: "Campo inicio" },
  fin: { value: 0, label: "Campo fin" },
  frecuenciaMinutos: "00:00:00",
  activo: true,
};

const api = (metodo, obj, id, catalogo) =>
  Crud_Catalogos(catalogo, "plataformas", metodo, id, obj, "", catalogo, "", []);

export const useWhatsappTramos = (idCliente, idPlataforma) => {
  const [tramos, setTramos] = useState([]);
  const [movimientosTipo, setMovimientosTipo] = useState([]);
  const [camposLogisticos, setCamposLogisticos] = useState([]);
  const [editando, setEditando] = useState(null);
  const [cargando, setCargando] = useState(false);

  const movimientosTipoRef = useRef([]);
  const camposLogisticosRef = useRef([]);

  useEffect(() => {
    if (!idCliente || !idPlataforma) return;

    setCargando(true);

    api("get", [], "", "configuracionWhatsappTramo/cliente/" + idCliente)
      .then(val => { setTramos(val || []); setCargando(false); })
      .catch(() => setCargando(false));

    api("get", [], "", "movimientosTipo/plataforma/" + idPlataforma)
      .then(val => {
        if (!val) return;
        const lista = val.map(m => ({ value: m.id, label: m.nombre }));
        movimientosTipoRef.current = lista;
        setMovimientosTipo(lista);
      });

  }, [idCliente, idPlataforma]);

  // Carga los campos ordenados cruzando nombres (camposLogisticosV2) con orden por plataforma (plataformaCamposLogisticosV2)
  const cargarCamposPorMovimiento = (idMovimientoTipo) => {
    if (!idMovimientoTipo || !idPlataforma) return Promise.resolve([]);

    const headers = {
      Authorization: "Bearer " + sessionStorage.getItem("tok"),
      "Content-Type": "application/json",
    };

    const urlNombres = `${conf.api_raiz}camposLogisticosV2/movimientoTipo/${idMovimientoTipo}`;
    const urlPlataforma = `${conf.api_raiz}plataformaCamposLogisticosV2/plataforma/${idPlataforma}/movimientoTipo/${idMovimientoTipo}`;

    return Promise.all([
      axios.get(urlNombres, { headers }),
      axios.get(urlPlataforma, { headers }),
    ]).then(([resNombres, resPlataforma]) => {
      const nombresMap = {};
      (resNombres.data || []).forEach(c => { nombresMap[c.id] = c.nombre; });

      console.log("[V2] nombresMap keys →", Object.keys(nombresMap));
      console.log("[V2] idCamposLogisticos en plataforma →", (resPlataforma.data || []).map(c => c.idCamposLogisticos));

      const campos = (resPlataforma.data || []).map(c => ({
        value: c.idCamposLogisticos,
        label: nombresMap[c.idCamposLogisticos] || String(c.idCamposLogisticos),
        orden: c.orden,
      }));

      camposLogisticosRef.current = campos;
      setCamposLogisticos(campos);
      return campos;
    }).catch(err => {
      console.error("[V2] Error cargando campos:", err?.response?.status, err?.response?.data);
      return [];
    });
  };

  const recargarTramos = () =>
    api("get", [], "", "configuracionWhatsappTramo/cliente/" + idCliente)
      .then(val => setTramos(val || []));

  const resetForm = () => setEditando(null);

  const editandoDefaultValues = editando ? {
    idMovimientoTipo:
      (movimientosTipoRef.current.length > 0 ? movimientosTipoRef.current : movimientosTipo)
        .find(m => m.value === editando.idMovimientoTipo) || emptyTramo.idMovimientoTipo,
    nombre: editando.nombre || "",
    inicio:
      camposLogisticosRef.current.find(c => c.value === editando.inicio) || emptyTramo.inicio,
    fin:
      camposLogisticosRef.current.find(c => c.value === editando.fin) || emptyTramo.fin,
    frecuenciaMinutos: editando.frecuenciaMinutos || "00:00:00",
    activo: editando.activo !== undefined ? editando.activo : true,
  } : emptyTramo;

  const guardarTramo = (data) => {
    const obj = {
      idCliente,
      idMovimientoTipo: data.idMovimientoTipo.value,
      nombre: data.nombre.trim(),
      inicio: data.inicio.value,
      fin: data.fin.value,
      frecuenciaMinutos: data.frecuenciaMinutos,
      activo: data.activo,
    };
    if (editando) {
      const idConfig = editando.idConfig ?? editando.id;
      api("put", { ...obj, idConfig }, idConfig, "configuracionWhatsappTramo")
        .then(() => {
          NotificationManager.info("Tramo actualizado", "Guardado");
          recargarTramos();
          resetForm();
        });
    } else {
      api("post", obj, "", "configuracionWhatsappTramo")
        .then(() => {
          NotificationManager.info("Tramo guardado", "Guardado");
          recargarTramos();
          resetForm();
        });
    }
  };

  // Carga los campos con orden antes de abrir el formulario de edición
  const editarTramo = (t) => {
    cargarCamposPorMovimiento(t.idMovimientoTipo).then(() => setEditando(t));
  };

  const borrarTramo = (t) => {
    const idConfig = t.idConfig ?? t.id;
    api("delete", [], idConfig, "configuracionWhatsappTramo")
      .then(returnVal => {
        if (returnVal !== false) {
          NotificationManager.info("Tramo eliminado", "Guardado");
          setTramos(prev => prev.filter(tr => (tr.idConfig ?? tr.id) !== idConfig));
        } else {
          NotificationManager.error("No se pudo eliminar el tramo", "Error");
        }
      });
  };

  const getMovimientoLabel = (id) => {
    const lista = movimientosTipoRef.current.length > 0 ? movimientosTipoRef.current : movimientosTipo;
    return lista.find(m => m.value === id)?.label || String(id);
  };

  const getCampoLabel = (id) => {
    return camposLogisticosRef.current.find(c => c.value === id)?.label || String(id);
  };

  return {
    tramos,
    movimientosTipo,
    camposLogisticos,
    editando,
    editandoDefaultValues,
    cargando,
    cargarCamposPorMovimiento,
    guardarTramo,
    editarTramo,
    borrarTramo,
    resetForm,
    getMovimientoLabel,
    getCampoLabel,
  };
};
